import SA from 'scroll-animations-js';
import $ from "jquery";
import AOS from 'aos';
import {gsap} from "gsap";
//import {ScrollTrigger} from "gsap/ScrollTrigger";
import LocomotiveScroll from 'locomotive-scroll';
import "owl.carousel";
import axios from "axios";
import mask from "jquery-mask-plugin";
import Swal from "sweetalert2";
import lottie from 'lottie-web';

AOS.init();
const locomotiveScroll = new LocomotiveScroll();

jQuery(".menu-mobile").click(function () {
    jQuery(this).toggleClass("act");
    jQuery("header .menu-container").toggleClass("act");
    return false;
});

jQuery("header .menu-container .nav-menu a").click(function () {
    jQuery('.menu-mobile').toggleClass("act");
    jQuery("header .menu-container").toggleClass("act");
})
// Inicializar scroll-animations-js quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function () {
    // A biblioteca exporta como default, então pode ser SA.default ou SA diretamente
    const scrollAnimations = SA.default || SA;

    if (scrollAnimations && scrollAnimations.init) {
        scrollAnimations.init({
            delay: 0,
            duration: 1500,
            intersectionObserverOptions: {
                threshold: 0.1,
                root: null,
                rootMargin: '0px'
            },
        });
    }
});

$(document).on('click', 'a[data-click-collapse]', function (event) {
    event.preventDefault();
    const group = $(this).attr('data-click-collapse-group');
    const target = $(this).attr('data-click-collapse');
    $('[data-collapse-group="' + group + '"]').removeClass("act");
    $('a[data-click-collapse-group="' + group + '"]').removeClass("act");
    $('[data-collapse="' + target + '"]').addClass("act");
    $(this).addClass("act");

    if ($(this).attr('data-video')) {
        $('#change-video').attr("src", $(this).attr('data-video'));
        $('#change-video').parent().addClass("video-choice").removeClass("img-choice");
    }

    if ($(this).attr('data-img')) {
        $('#change-img').attr("src", $(this).attr('data-img'));
        $('#change-img').parent().addClass("img-choice").removeClass('video-choice');
    }
});

$(document).on('click', '[data-modal-template]', function (event) {
    event.preventDefault();
    const templateId = $(this).attr('data-modal-template');
    const $template = $('#' + templateId);
    if (!$template.length) {
        return;
    }

    const isVideoModal = $template.find('.ecossistema-video-modal').length > 0;

    Swal.fire({
        html: $template.html(),
        showConfirmButton: false,
        width: 'auto',
        customClass: {
            popup: isVideoModal ? 'estrategia-modal-popup ecossistema-video-popup' : 'estrategia-modal-popup',
            container: 'estrategia-modal-container'
        },
        backdrop: 'rgba(0, 7, 22, 0.85)',
        showCloseButton: true,
        closeButtonHtml: `
                <span class="estrategia-modal-close" aria-hidden="true">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18" stroke="#7AE2E6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6 6L18 18" stroke="#7AE2E6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>`
    });
});

// Botão flutuante - Abrir modal de contato (manual)
$(document).on('click', '#floating-button', function (event) {
    event.preventDefault();
    const $modal = $('#contato-modal');
    if (!$modal.length) {
        return;
    }

    // Resetar estado
    resetForm();

    // Abrir modal
    $modal.addClass('active');
    $('body').css('overflow', 'hidden');

    // Garantir que step 1 está visível
    setTimeout(function () {
        showStep(1);
    }, 100);
});

// Fechar modal ao clicar no overlay ou botão fechar
$(document).on('click', '.contato-modal__overlay, .contato-modal__close', function (event) {
    event.preventDefault();
    const $modal = $('#contato-modal');
    $modal.removeClass('active');
    $('body').css('overflow', '');

    // Resetar estado ao fechar
    phoneToken = null;
    currentPhone = null;
    resetForm();
});

// Prevenir fechamento ao clicar no conteúdo da modal
$(document).on('click', '.contato-modal__content', function (event) {
    event.stopPropagation();
});

// Lógica dos botões de ação
$(document).on('click', '.contato-modal__btn', function () {
    // Só permitir mudança de ação no step 1
    if (currentStep !== 1) {
        return;
    }

    $('.contato-modal__btn').removeClass('active');
    $(this).addClass('active');

    // Resetar mensagem
    updateModalMessage('');
});

// Permitir submit ao pressionar Enter em qualquer campo
$(document).on('keypress', '#contato-form input, #contato-form select', function (event) {
    if (event.which === 13) { // Enter
        event.preventDefault();
        $('#contato-form').submit();
    }
});

// Função para formatar telefone brasileiro para padrão da API (5534984277746)
function formatPhoneForAPI(phone) {
    // Remove todos os caracteres não numéricos
    let cleaned = phone.replace(/\D/g, '');

    // Se começar com 0, remove
    if (cleaned.startsWith('0')) {
        cleaned = cleaned.substring(1);
    }

    // Se não começar com 55, adiciona
    if (!cleaned.startsWith('55')) {
        cleaned = '55' + cleaned;
    }

    return cleaned;
}

// Função para atualizar mensagem no modal
function updateModalMessage(message, isError = false, isSuccess = false) {
    const $message = $('#contato-message');
    if (message) {
        $message.text(message);
        $message.css('display', 'block');

        // Remover todas as classes de estado
        $message.removeClass('contato-modal__message--error contato-modal__message--success');

        // Adicionar classe apropriada
        if (isError) {
            $message.addClass('contato-modal__message--error');
        } else if (isSuccess) {
            $message.addClass('contato-modal__message--success');
        }
    } else {
        $message.css('display', 'none');
        $message.removeClass('contato-modal__message--error contato-modal__message--success');
    }
}

// Função para mostrar/ocultar loading
function setLoading(isLoading) {
    const $submitBtn = $(`.contato-modal__step[data-step="${currentStep}"] .contato-modal__submit`);
    const $form = $('#contato-form');
    const $loading = $('#contato-loading');

    if (isLoading) {
        $submitBtn.prop('disabled', true);
        $form.find('input, select').prop('disabled', true);
        $loading.addClass('active');
        $form.css('opacity', '0.5');
        $form.css('pointer-events', 'none');
    } else {
        $submitBtn.prop('disabled', false);
        $loading.removeClass('active');
        $form.css('opacity', '1');
        $form.css('pointer-events', 'auto');
        $form.find('input, select').prop('disabled', false);
    }
}

// Função para resetar formulário
function resetForm() {
    const $form = $('#contato-form');

    $form[0].reset();
    $('.contato-modal__btn').removeClass('active');
    $('.contato-modal__btn--primary').addClass('active');
    updateModalMessage('');

    // Mostrar formulário novamente
    $form.show();

    // Resetar variáveis
    phoneToken = null;
    currentPhone = null;
    currentStep = 1;
    formData = {
        nome: '',
        email: '',
        whatsapp: '',
        lista: ''
    };

    // Voltar para step 1
    showStep(1);
}

// Função para abrir modal de contato e focar no campo nome
function openContatoModalAndFocusNome() {
    const $modal = $('#contato-modal');
    if (!$modal.length) {
        return;
    }

    // Resetar estado
    resetForm();

    // Abrir modal
    $modal.addClass('active');
    $('body').css('overflow', 'hidden');

    // Garantir que step 1 está visível e focar no campo nome
    setTimeout(function () {
        showStep(1);
        $('input[name="nome"]').focus();
    }, 100);
}

// Variáveis para gerenciar steps e dados
let phoneToken = null;
let currentPhone = null;
let currentStep = 1;
let formData = {
    nome: '',
    email: '',
    whatsapp: '',
    lista: ''
};

// Função para mostrar step específico
function showStep(step) {
    // Remover required de todos os campos para evitar erro de validação
    $('#contato-form input[required], #contato-form select[required]').each(function () {
        $(this).removeAttr('required');
    });

    // Ocultar todos os steps
    $('.contato-modal__step').each(function () {
        $(this).css({
            'display': 'none',
            'visibility': 'hidden',
            'opacity': '0'
        });
    });

    // Mostrar step atual com display flex
    const $currentStep = $(`#step-${step}`);
    if ($currentStep.length) {
        $currentStep.css({
            'display': 'flex',
            'visibility': 'visible',
            'opacity': '1'
        });
        currentStep = step;

        // Adicionar required apenas nos campos do step atual
        if (step === 1) {
            $('input[name="nome"]').attr('required', 'required');
            $('input[name="email"]').attr('required', 'required');
            $('input[name="whatsapp"]').attr('required', 'required');
        } else if (step === 2) {
            $('#contato-otp').attr('required', 'required');
        } else if (step === 3) {
            $('#contato-lista').attr('required', 'required');
        }
    }

    // Aplicar máscaras quando necessário
    if (step === 1) {
        setTimeout(function () {
            $('input[name="whatsapp"]').mask('(00) 00000-0000');
        }, 100);
    } else if (step === 2) {
        setTimeout(function () {
            $('#contato-otp').mask('000000');
            $('#contato-otp').focus();
        }, 100);
    } else if (step === 3) {
        setTimeout(function () {
            $('#contato-lista').focus();
        }, 100);
    }
}

// Função para salvar dados do formulário
function saveFormData() {
    formData.nome = $('input[name="nome"]').val().trim();
    formData.email = $('input[name="email"]').val().trim();
    formData.whatsapp = $('input[name="whatsapp"]').val().trim();
    formData.lista = $('#contato-lista').val();
}

// Submit do formulário de contato
$(document).on('submit', '#contato-form', function (event) {
    event.preventDefault();

    // Step 1: Coletar dados básicos e enviar OTP
    if (currentStep === 1) {
        const $activeBtn = $('.contato-modal__btn.active');
        const action = $activeBtn.length ? ($activeBtn.attr('data-action') || $activeBtn.data('action') || 'reuniao') : 'reuniao';
        const normalizedAction = String(action).trim().toLowerCase();

        const nome = $('input[name="nome"]').val().trim();
        const email = $('input[name="email"]').val().trim();
        const whatsapp = $('input[name="whatsapp"]').val().trim();

        // Validação básica
        if (!nome || !email || !whatsapp) {
            updateModalMessage('Por favor, preencha todos os campos obrigatórios.', true);
            return;
        }

        // Se for ação de reunião, usar fluxo normal
        if (normalizedAction === 'reuniao') {
            requestMeeting(nome, email, whatsapp);
            return;
        }

        // Salvar dados e enviar OTP
        saveFormData();
        const formattedPhone = formatPhoneForAPI(whatsapp);
        requestOTP(formattedPhone, nome, email);
        return;
    }

    // Step 2: Confirmar código OTP
    if (currentStep === 2) {
        const otpCode = $('#contato-otp').val().trim();

        if (!otpCode || otpCode.length !== 6) {
            updateModalMessage('Por favor, digite o código de 6 dígitos.', true);
            return;
        }

        const formattedPhone = formatPhoneForAPI(formData.whatsapp);
        confirmOTPAndSend(formattedPhone, otpCode);
        return;
    }

    // Step 3: Enviar mensagem
    if (currentStep === 3) {
        const lista = $('#contato-lista').val();

        if (!lista || lista === '') {
            updateModalMessage('Por favor, selecione uma categoria.', true);
            return;
        }

        formData.lista = lista;
        sendTestMessage(phoneToken, formData.nome, formatPhoneForAPI(formData.whatsapp), formData.email, lista);
        return;
    }
});

// Função para solicitar reunião
function requestMeeting(nome, email, whatsapp) {
    setLoading(true);

    const apiUrl = b2list_api.restUrl + b2list_api.endpoints.requestMeeting;

    axios.post(apiUrl, {
        nome: nome,
        email: email,
        whatsapp: whatsapp,
        site_url: window.location.href
    }, {
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': b2list_api.nonce
        }
    })
        .then(response => {
            setLoading(false);

            if (response.data && response.data.success) {
                // Abrir link do Google Calendar
                window.open('https://calendar.app.google/Sopv3gmExNcrdRQ4A', '_blank');
                
                // Ocultar formulário e mostrar mensagem de sucesso
                $('#contato-form').hide();
                updateModalMessage('Obrigado! Em breve entraremos em contato com você.', false, true);
                setTimeout(() => {
                    const $modal = $('#contato-modal');
                    $modal.removeClass('active');
                    $('body').css('overflow', '');
                    resetForm();
                }, 3000);
            } else {
                updateModalMessage(response.data?.message || "Erro ao enviar solicitação. Tente novamente.", true);
            }
        })
        .catch(error => {
            setLoading(false);
            const errorMsg = error.response?.data?.message || error.response?.data?.data?.message || "Erro ao enviar solicitação. Tente novamente.";
            updateModalMessage(errorMsg, true);
        });
}

// Função para solicitar OTP
function requestOTP(phone, nome, email) {
    setLoading(true);

    const apiUrl = b2list_api.restUrl + b2list_api.endpoints.requestOtp;

    axios.post(apiUrl, {
        phone: phone
    }, {
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': b2list_api.nonce
        }
    })
        .then(response => {
            setLoading(false);

            if (response.data && response.data.success) {
                currentPhone = phone;
                updateModalMessage('Código de verificação enviado! Digite o código recebido no WhatsApp.');
                // Avançar para step 2
                showStep(2);
            } else {
                updateModalMessage(response.data?.message || "Erro ao solicitar código. Tente novamente.", true);
            }
        })
        .catch(error => {
            setLoading(false);

            if (error.response && error.response.status === 429) {
                const retryAfter = error.response.data?.data?.retryAfterSeconds || error.response.data?.retryAfterSeconds || 60;
                updateModalMessage(`Muitas tentativas. Aguarde ${retryAfter} segundos antes de tentar novamente.`, true);
            } else {
                const errorMsg = error.response?.data?.message || error.response?.data?.data?.message || "Erro ao solicitar código. Tente novamente.";
                updateModalMessage(errorMsg, true);
            }
        });
}

// Função para confirmar OTP
function confirmOTPAndSend(phone, code) {
    setLoading(true);

    const confirmUrl = b2list_api.restUrl + b2list_api.endpoints.confirmOtp;

    axios.post(confirmUrl, {
        phone: phone,
        code: code
    }, {
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': b2list_api.nonce
        }
    })
        .then(response => {
            setLoading(false);

            if (response.data && response.data.success && response.data.data && response.data.data.token) {
                phoneToken = response.data.data.token;
                updateModalMessage('Código confirmado! Selecione a categoria e envie a mensagem.');
                // Avançar para step 3
                showStep(3);
            } else {
                updateModalMessage(response.data?.message || 'Token não recebido. Tente novamente.', true);
            }
        })
        .catch(error => {
            setLoading(false);

            if (error.response && error.response.status === 400) {
                const errorMsg = error.response?.data?.message || error.response?.data?.data?.message || 'Código inválido! Verifique e tente novamente.';
                updateModalMessage(errorMsg, true);
                $('#contato-otp').val('');
                setTimeout(function () {
                    $('#contato-otp').focus();
                }, 100);
            } else {
                const errorMsg = error.response?.data?.message || error.response?.data?.data?.message || "Erro ao confirmar código. Tente novamente.";
                updateModalMessage(errorMsg, true);
            }
        });
}

// Função para enviar mensagem de teste
function sendTestMessage(token, nome, phone, email, lista) {
    setLoading(true);

    const sendUrl = b2list_api.restUrl + b2list_api.endpoints.sendTestMessage;

    axios.post(sendUrl, {
        token: token,
        action: "submit",
        name: nome,
        phone: phone,
        email: email,
        list: parseInt(lista) || 0
    }, {
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': b2list_api.nonce
        }
    })
        .then(response => {
            setLoading(false);

            // Verificar sucesso em múltiplos níveis (response.data.success ou response.data.data.success)
            const isSuccess = (response.data && response.data.success) ||
                (response.data && response.data.data && response.data.data.success);

            if (isSuccess) {
                // Ocultar formulário e mostrar mensagem de sucesso
                $('#contato-form').hide();
                updateModalMessage('Obrigado! Sua mensagem de teste foi enviada com sucesso. Em breve você receberá no seu WhatsApp!', false, true);

                // Fechar modal após 4 segundos
                setTimeout(() => {
                    const $modal = $('#contato-modal');
                    $modal.removeClass('active');
                    $('body').css('overflow', '');
                    resetForm();
                    phoneToken = null;
                    currentPhone = null;
                }, 4000);
            } else {
                const errorMsg = response.data?.message ||
                    response.data?.data?.message ||
                    "Erro ao enviar mensagem. Tente novamente.";
                updateModalMessage(errorMsg, true);
            }
        })
        .catch(error => {
            setLoading(false);

            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                updateModalMessage('Token expirado! Solicite um novo código.', true);
                phoneToken = null;
                // Voltar para step 2 para solicitar novo código
                showStep(2);
                $('#contato-otp').val('');
            } else if (error.response && error.response.status === 400) {
                const errorMsg = error.response?.data?.message || error.response?.data?.data?.message || "Dados inválidos. Verifique as informações e tente novamente.";
                updateModalMessage(errorMsg, true);
            } else {
                const errorMsg = error.response?.data?.message || error.response?.data?.data?.message || "Erro ao enviar mensagem. Tente novamente.";
                updateModalMessage(errorMsg, true);
            }
        });
}

$(document).on('click', '[data-ecossistema-tab]', function (event) {
    event.preventDefault();
    const target = $(this).attr('data-ecossistema-tab');
    if (!target) return;
    $('[data-ecossistema-tab]').removeClass('act');
    $(this).addClass('act');
    $('[data-ecossistema-panel]').removeClass('act');
    $('[data-ecossistema-panel="' + target + '"]').addClass('act');
});

window.onscroll = function () {
    var body = document.body;

    // Se o usuário estiver no topo da página (scrollY == 0), adicionar a classe 'top'
    if (window.scrollY === 0) {
        body.classList.add('top');
    } else {
        body.classList.remove('top');
    }
};

// Ao carregar a página, verifica se está no topo e adiciona a classe 'top' se for o caso
window.onload = function () {
    if (window.scrollY === 0) {
        document.body.classList.add('top');
    }
};


// Inicialização da animação Lottie
document.addEventListener('DOMContentLoaded', function () {
    const animationContainer = document.querySelector('.ecossistema .animation');
    if (animationContainer) {
        // Obtém o caminho base do tema WordPress
        const themePath = site_url.themeUri || (site_url.url + '/wp-content/themes/theme-b2list');
        const animationPath = themePath + '/animation/animacao.json';

        // Inicializa a animação Lottie
        const anim = lottie.loadAnimation({
            container: animationContainer,
            renderer: 'svg', // ou 'canvas', 'html'
            loop: true,
            autoplay: true,
            path: animationPath
        });

        // Controlar a animação baseado no scroll (inicia quando entra na viewport)
        let animationStarted = false;
        const observerOptions = {
            root: null,
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !animationStarted) {
                    animationStarted = true;
                    anim.play();
                }
            });
        }, observerOptions);

        observer.observe(animationContainer);
    }
});


let textLengthArray = [];

function type(index) {
    let paragraph = document.getElementsByClassName("typed")[index];
    let text = paragraph.getAttribute("data-text");
    let textLength = textLengthArray[index];

    if (!textLength) {
        textLength = 0;
        textLengthArray[index] = 0;
        paragraph.innerText = "";
    }

    let textChar = text.charAt(textLength++);
    let charElement = document.createTextNode(textChar);
    paragraph.appendChild(charElement);

    if (textLength < text.length + 1) {
        textLengthArray[index] = textLength;
        setTimeout(() => {
            type(index);
        }, 50);
    }
}

function countUp(index) {
    let counter = document.getElementsByClassName("counter")[index];
    let targetValue = parseFloat(counter.getAttribute("data-target")); // Pode ser float ou int
    let integerPart = Math.floor(targetValue); // Parte inteira
    let decimalPart = targetValue % 1; // Parte decimal
    let currentValue = 0; // Valor inicial

    // Calcula incremento dinâmico baseado no valor alvo
    // Valores altos (ex: 990) são mais rápidos, valores baixos são mais lentos
    const intervalo = 16; // Atualiza a cada 16ms (~60fps)

    // Duração base: valores pequenos levam mais tempo, valores grandes menos tempo
    // Para valores até 100: ~3 segundos
    // Para valores acima de 100: proporcionalmente mais rápido
    let duracaoTotal;
    if (integerPart <= 100) {
        duracaoTotal = 3000; // 3 segundos para valores pequenos
    } else if (integerPart <= 500) {
        duracaoTotal = 2500; // 2.5 segundos para valores médios
    } else {
        duracaoTotal = 2000; // 2 segundos para valores altos (990, etc)
    }

    const totalSteps = duracaoTotal / intervalo;
    // Calcula incremento preciso (pode ser decimal para valores pequenos)
    let increment = integerPart / totalSteps;

    function countIntegers() {
        if (currentValue < integerPart) {
            // Incrementa o valor (pode ser decimal)
            currentValue += increment;

            // Garante que não ultrapasse o valor alvo
            if (currentValue >= integerPart) {
                currentValue = integerPart;
            }

            counter.innerText = Math.floor(currentValue); // Atualiza o contador
            setTimeout(countIntegers, intervalo);
        } else {
            currentValue = integerPart; // Garante o valor final
            counter.innerText = currentValue; // Exibe o valor inteiro final
            if (decimalPart > 0) {
                setTimeout(countDecimals, intervalo); // Inicia a contagem decimal
            }
        }
    }

    function countDecimals() {
        let decimalCurrent = 0; // Começa do 0 para os decimais
        const decimalSteps = 20; // Número de passos para decimais
        const decimalIncrement = decimalPart / decimalSteps; // Incrementa em etapas menores

        function updateDecimals() {
            if (decimalCurrent < decimalPart) {
                decimalCurrent += decimalIncrement;

                // Evita ultrapassar o valor decimal
                if (decimalCurrent > decimalPart) {
                    decimalCurrent = decimalPart;
                }

                counter.innerText = `${integerPart}${decimalCurrent.toFixed(1).substring(1)}`; // Atualiza ex: "5.1"
                setTimeout(updateDecimals, intervalo);
            } else {
                counter.innerText = targetValue.toFixed(1); // Garante o valor final exato
            }
        }

        updateDecimals();
    }

    countIntegers();
}

function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function checkScroll() {
    let paragraphs = document.querySelectorAll(".typed");
    paragraphs.forEach((paragraph, index) => {
        if (isElementInViewport(paragraph) && !paragraph.classList.contains('started')) {
            paragraph.classList.add('started');
            type(index); // Inicia a animação de digitação
        }
    });

    let counters = document.querySelectorAll(".counter");
    counters.forEach((counter, index) => {
        if (isElementInViewport(counter) && !counter.classList.contains('counted')) {
            counter.classList.add('counted');
            // Todos começam ao mesmo tempo (sem delay)
            countUp(index);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    let paragraphs = document.querySelectorAll(".typed");
    paragraphs.forEach((paragraph, index) => {
        let text = paragraph.innerText;
        paragraph.setAttribute("data-text", text);
    });

    let counters = document.querySelectorAll(".counter");
    counters.forEach(counter => {
        counter.innerText = "0"; // Inicializa os contadores com zero
    });

    window.addEventListener("scroll", checkScroll);
    checkScroll(); // Checa a visibilidade inicial no carregamento da página

    // Carrossel de Depoimentos
    const depoimentosTrack = document.querySelector('.depoimentos-cards-track');
    const depoimentosPrev = document.querySelector('.depoimentos-nav-prev');
    const depoimentosNext = document.querySelector('.depoimentos-nav-next');

    if (depoimentosTrack && depoimentosPrev && depoimentosNext) {
        function getCardWidth() {
            const card = depoimentosTrack.querySelector('.depoimento-card');
            return card ? card.offsetWidth : 416;
        }

        function getGap() {
            return window.innerWidth <= 768 ? 24 : 40;
        }

        function getScrollAmount() {
            return getCardWidth() + getGap();
        }

        function getMaxScroll() {
            return depoimentosTrack.scrollWidth - depoimentosTrack.clientWidth;
        }

        let currentScroll = 0;

        // Função para atualizar estado dos botões
        function updateButtons() {
            const maxScroll = getMaxScroll();
            depoimentosPrev.disabled = currentScroll <= 0;
            depoimentosNext.disabled = currentScroll >= maxScroll;
        }

        // Navegação anterior
        depoimentosPrev.addEventListener('click', () => {
            const scrollAmount = getScrollAmount();
            currentScroll = Math.max(0, currentScroll - scrollAmount);
            depoimentosTrack.scrollTo({
                left: currentScroll,
                behavior: 'smooth'
            });
            setTimeout(updateButtons, 300);
        });

        // Navegação próxima
        depoimentosNext.addEventListener('click', () => {
            const scrollAmount = getScrollAmount();
            const maxScroll = getMaxScroll();
            currentScroll = Math.min(maxScroll, currentScroll + scrollAmount);
            depoimentosTrack.scrollTo({
                left: currentScroll,
                behavior: 'smooth'
            });
            setTimeout(updateButtons, 300);
        });

        // Atualizar scroll ao arrastar
        depoimentosTrack.addEventListener('scroll', () => {
            currentScroll = depoimentosTrack.scrollLeft;
            updateButtons();
        });

        // Inicializar estado dos botões
        updateButtons();

        // Atualizar em resize
        window.addEventListener('resize', () => {
            updateButtons();
        });
    }

    // Animação das frases "Alavanca" no ecossistema
    const listaAlavanca = document.getElementById("frases-alavanca-list");
    if (listaAlavanca) {
        const frasesAlavanca = listaAlavanca.children;
        const totalFrasesAlavanca = frasesAlavanca.length;

        if (totalFrasesAlavanca > 0) {
            // Clona todas as frases para criar loop infinito
            for (let i = 0; i < totalFrasesAlavanca; i++) {
                const clone = frasesAlavanca[i].cloneNode(true);
                listaAlavanca.appendChild(clone);
            }

            const alturaFraseAlavanca = window.innerWidth > 768 ? 2.5 : 2.0; // rem
            const duracaoAnimacao = 1.2; // segundos para animar
            const duracaoPausa = 1.5; // segundos de pausa em cada frase

            // Cria timeline GSAP com pausas
            const tlAlavanca = gsap.timeline({repeat: -1});

            for (let i = 0; i < totalFrasesAlavanca; i++) {
                tlAlavanca.to(listaAlavanca, {
                    y: `-${(i + 1) * alturaFraseAlavanca}rem`,
                    duration: duracaoAnimacao,
                    ease: "power2.inOut"
                });
                tlAlavanca.to({}, {duration: duracaoPausa - duracaoAnimacao}); // Pausa
            }

            // Reset suave quando chegar no final
            tlAlavanca.set(listaAlavanca, {y: "0rem"});
        }
    }

    // Animação das frases do topo
    function initFrasesAnimacao() {
        // Animação das frases do conteúdo
        const lista = document.getElementById("frases-list");
        if (lista) {
            const frases = lista.children;
            const totalFrases = frases.length;

            if (totalFrases > 0) {
                // Remove animação CSS se existir
                lista.style.animation = "none";

                // Clona todas as frases para criar loop infinito
                for (let i = 0; i < totalFrases; i++) {
                    const clone = frases[i].cloneNode(true);
                    lista.appendChild(clone);
                }

                const alturaFrase = window.innerWidth > 768 ? 2.5 : 2.0; // rem
                const duracaoAnimacao = 1.2; // segundos para animar
                const duracaoPausa = 1.5; // segundos de pausa em cada frase

                // Cria timeline GSAP com pausas
                const tl = gsap.timeline({repeat: -1});

                for (let i = 0; i < totalFrases; i++) {
                    tl.to(lista, {
                        y: `-${(i + 1) * alturaFrase}rem`,
                        duration: duracaoAnimacao,
                        ease: "power2.inOut"
                    });
                    tl.to({}, {duration: duracaoPausa - duracaoAnimacao}); // Pausa
                }

                // Reset suave quando chegar no final
                tl.set(lista, {y: "0rem"});
            }
        }

        // Animação das frases do vídeo
        const listaVideo = document.getElementById("frases-video-list");
        if (listaVideo) {
            const frasesVideo = listaVideo.children;
            const totalFrasesVideo = frasesVideo.length;

            if (totalFrasesVideo > 0) {
                // Clona todas as frases para criar loop infinito
                for (let i = 0; i < totalFrasesVideo; i++) {
                    const clone = frasesVideo[i].cloneNode(true);
                    listaVideo.appendChild(clone);
                }
                const alturaFraseVideo = window.innerWidth > 768 ? 5.625 : 3.0; // rem (90px = 5.625rem)
                const duracaoAnimacao = 1.2; // segundos para animar
                const duracaoPausa = 1.5; // segundos de pausa em cada frase

                // Cria timeline GSAP com pausas
                const tlVideo = gsap.timeline({repeat: -1});

                for (let i = 0; i < totalFrasesVideo; i++) {
                    tlVideo.to(listaVideo, {
                        y: `-${(i + 1) * alturaFraseVideo}rem`,
                        duration: duracaoAnimacao,
                        ease: "power2.inOut"
                    });
                    tlVideo.to({}, {duration: duracaoPausa - duracaoAnimacao}); // Pausa
                }

                // Reset suave quando chegar no final
                tlVideo.set(listaVideo, {y: "0rem"});
            }
        }
    }

    // Inicializa animação das frases do topo
    initFrasesAnimacao();

    // Scroll suave para âncoras e gerenciar header compact
    const header = document.querySelector('header');
    if (header) {
        function checkAnchor() {
            const hash = window.location.hash;
            const scrollY = window.scrollY;

            // Só diminui o header se houver hash E não estiver no topo, ou se scroll > 100px
            if ((hash && scrollY > 50) || scrollY > 100) {
                header.classList.add('header-compact');
            } else {
                header.classList.remove('header-compact');
            }
        }

        // Função para scroll suave até a âncora
        function smoothScrollToAnchor(hash) {
            if (!hash) return;

            const targetId = hash.substring(1); // Remove o #
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const headerHeight = header.offsetHeight;
                const targetPosition = targetElement.offsetTop - headerHeight - 20; // 20px de espaçamento

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });

                // Atualizar hash sem causar scroll adicional
                history.pushState(null, null, hash);
            }
        }

        // Verificar ao carregar a página
        checkAnchor();

        // Se houver hash na URL ao carregar, fazer scroll suave (exceto #demo)
        if (window.location.hash && window.location.hash !== '#demo') {
            setTimeout(() => {
                smoothScrollToAnchor(window.location.hash);
            }, 100);
        }

        // Verificar quando a URL muda (incluindo hash)
        window.addEventListener('hashchange', (e) => {
            // Se for #demo, não fazer nada aqui (será tratado pelo listener específico)
            if (window.location.hash === '#demo') {
                return;
            }
            if (window.location.hash !== '#demo') {
                smoothScrollToAnchor(window.location.hash);
            }
            setTimeout(checkAnchor, 500);
        });

        // Verificar ao fazer scroll
        let scrollTimeout;
        window.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(checkAnchor, 10);
        });

        // Interceptar cliques em links de âncora
        document.querySelectorAll('a[href^="#"]').forEach(link => {
            link.addEventListener('click', (e) => {
                const href = link.getAttribute('href');

                // Ignorar links vazios ou apenas #
                if (href === '#' || href === '') {
                    return;
                }

                // Se for #demo, atualizar hash e abrir modal
                if (href === '#demo') {
                    e.preventDefault();
                    e.stopPropagation(); // Prevenir que outros listeners sejam executados
                    window.location.hash = '#demo';
                    // Aguardar um pouco para garantir que o hash foi atualizado
                    setTimeout(() => {
                        openContatoModalAndFocusNome();
                    }, 50);
                    return;
                }

                e.preventDefault();
                smoothScrollToAnchor(href);

                // Verificar header após scroll
                setTimeout(checkAnchor, 500);
            });
        });
    }


    // Ajustar animação das logos usando GSAP para animação infinita
    let logosAnimation = null; // Variável para armazenar a animação GSAP
    let initAttempts = 0;
    const MAX_INIT_ATTEMPTS = 10;

    function ajustarAnimacaoLogos() {
        const logosTrack = document.querySelector('.logos-track');
        if (!logosTrack) {
            if (initAttempts < MAX_INIT_ATTEMPTS) {
                initAttempts++;
                setTimeout(ajustarAnimacaoLogos, 200);
            }
            return;
        }

        const logoItems = Array.from(logosTrack.querySelectorAll('.logo-item'));
        if (logoItems.length === 0) {
            if (initAttempts < MAX_INIT_ATTEMPTS) {
                initAttempts++;
                setTimeout(ajustarAnimacaoLogos, 200);
            }
            return;
        }

        // Como há duas cópias idênticas, calculamos a largura da primeira metade
        const totalItems = logoItems.length;
        const halfItems = Math.floor(totalItems / 2);

        if (halfItems === 0) {
            return;
        }

        const isMobile = window.innerWidth <= 768;

        // Garante que o wrapper tem overflow hidden
        const logosWrapper = logosTrack.parentElement;
        if (logosWrapper && logosWrapper.classList.contains('logos-wrapper')) {
            logosWrapper.style.overflow = 'hidden';
            logosWrapper.style.width = '100%';
        }

        // Garante que o track tem as propriedades necessárias
        logosTrack.style.willChange = 'transform';
        logosTrack.style.display = 'flex';

        // Função interna para calcular e criar animação
        const criarAnimacao = () => {
            // Força reflow múltiplas vezes para garantir cálculo no mobile
            void logosTrack.offsetHeight;
            void logosTrack.scrollWidth;
            void logoItems[0].offsetWidth;

            // Aguarda um frame para garantir que o layout está estável
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    // Calcula gap usando getBoundingClientRect
                    let gapPx = 0;
                    if (logoItems.length >= 2) {
                        const firstRect = logoItems[0].getBoundingClientRect();
                        const secondRect = logoItems[1].getBoundingClientRect();
                        gapPx = Math.max(0, secondRect.left - firstRect.right);
                    }

                    // Fallback para gap se não conseguir calcular
                    if (gapPx === 0 || gapPx < 10) {
                        gapPx = isMobile ? 32 : 48;
                    }

                    // Calcula a largura total da primeira metade incluindo gaps
                    let primeiraMetadeWidth = 0;
                    for (let i = 0; i < halfItems; i++) {
                        const item = logoItems[i];
                        const itemRect = item.getBoundingClientRect();
                        const itemWidth = itemRect.width || item.offsetWidth || itemRect.right - itemRect.left;

                        if (itemWidth > 0) {
                            primeiraMetadeWidth += itemWidth;

                            // Adiciona gap entre itens (exceto após o último)
                            if (i < halfItems - 1) {
                                primeiraMetadeWidth += gapPx;
                            }
                        }
                    }

                    // Se ainda não tem dimensões válidas, tenta novamente
                    if (primeiraMetadeWidth === 0 || primeiraMetadeWidth < 100) {
                        if (initAttempts < MAX_INIT_ATTEMPTS) {
                            initAttempts++;
                            setTimeout(ajustarAnimacaoLogos, 300);
                        } else {
                            console.error('❌ Não foi possível calcular dimensões após múltiplas tentativas');
                        }
                        return;
                    }

                    // Calcula duração baseada na distância percorrida e velocidade desejada
                    const velocidadePxPorSegundo = isMobile ? 35 : 50;
                    const distanciaPx = primeiraMetadeWidth;
                    const duration = Math.max(10, Math.min(30, distanciaPx / velocidadePxPorSegundo));

                    // Remove animação CSS existente
                    logosTrack.style.animation = 'none';
                    logosTrack.style.animationName = 'none';
                    logosTrack.style.animationDuration = 'none';
                    logosTrack.style.transform = '';

                    // Mata a animação GSAP anterior se existir
                    if (logosAnimation) {
                        logosAnimation.kill();
                        logosAnimation = null;
                    }

                    // Reseta a posição para 0
                    gsap.set(logosTrack, {
                        x: 0,
                        clearProps: 'transform'
                    });

                    // Cria animação GSAP infinita
                    logosAnimation = gsap.to(logosTrack, {
                        x: -primeiraMetadeWidth,
                        duration: duration,
                        ease: 'none',
                        repeat: -1,
                        immediateRender: true,
                        force3D: true,
                        paused: false, // Garante que não está pausada
                        onStart: () => {
                            console.log('🚀 Animação GSAP iniciada no mobile:', isMobile);
                        }
                    });

                    // Força play explícito e verifica se está rodando
                    if (logosAnimation) {
                        if (logosAnimation.paused()) {
                            logosAnimation.play();
                        }

                        // Verificação adicional após um pequeno delay
                        setTimeout(() => {
                            if (logosAnimation && logosAnimation.paused()) {
                                console.warn('⚠️ Animação estava pausada, forçando play...');
                                logosAnimation.play();
                            }

                            // Verifica se a animação está realmente rodando
                            const currentX = gsap.getProperty(logosTrack, 'x');
                            console.log('📍 Posição atual X:', currentX, 'px');

                            if (currentX === 0 && logosAnimation && !logosAnimation.paused()) {
                                console.warn('⚠️ Animação criada mas posição não está mudando. Tentando novamente...');
                                // Tenta recriar a animação
                                setTimeout(() => {
                                    ajustarAnimacaoLogos();
                                }, 500);
                            }
                        }, 100);
                    }

                    // Debug
                    console.log('✅ Logos Animation GSAP Criada:', {
                        primeiraMetadeWidth: primeiraMetadeWidth.toFixed(2) + 'px',
                        duration: duration.toFixed(2) + 's',
                        gapPx: gapPx.toFixed(2) + 'px',
                        isMobile: isMobile,
                        velocidade: velocidadePxPorSegundo + 'px/s',
                        animationActive: !!logosAnimation,
                        animationPaused: logosAnimation ? logosAnimation.paused() : 'N/A',
                        totalItems: totalItems,
                        halfItems: halfItems
                    });
                });
            });
        };

        // Executa imediatamente
        criarAnimacao();
    }

    // Executa quando o DOM estiver pronto
    ajustarAnimacaoLogos();

    // Aguarda todas as imagens carregarem para cálculo preciso
    window.addEventListener('load', () => {
        initAttempts = 0; // Reset contador
        setTimeout(() => {
            ajustarAnimacaoLogos();
        }, 300);
    });

    // Listener para quando a página fica visível (importante no mobile)
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden && logosAnimation && logosAnimation.paused()) {
            logosAnimation.play();
        }
    });

    // Listener adicional para garantir inicialização após interação do usuário (mobile)
    let userInteracted = false;
    const initOnInteraction = () => {
        if (!userInteracted) {
            userInteracted = true;
            setTimeout(() => {
                if (!logosAnimation || logosAnimation.paused()) {
                    ajustarAnimacaoLogos();
                }
            }, 100);
        }
    };

    document.addEventListener('touchstart', initOnInteraction, {once: true});
    document.addEventListener('click', initOnInteraction, {once: true});
    document.addEventListener('scroll', initOnInteraction, {once: true});

    // Recalcula ao redimensionar a janela (debounce)
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            initAttempts = 0; // Reset contador
            ajustarAnimacaoLogos();
        }, 300);
    });

    // Pausa a animação no hover (apenas desktop)
    const logosTrackElement = document.querySelector('.logos-track');
    if (logosTrackElement && window.innerWidth > 768) {
        logosTrackElement.addEventListener('mouseenter', function () {
            if (logosAnimation && !logosAnimation.paused()) {
                logosAnimation.pause();
            }
        });
        logosTrackElement.addEventListener('mouseleave', function () {
            if (logosAnimation && logosAnimation.paused()) {
                logosAnimation.resume();
            }
        });
    }

    // ============================================
    // GERENCIAMENTO DO HASH #demo
    // ============================================
    // Colocado no final para garantir que todas as funções estejam definidas

    // Função para verificar e abrir modal se hash for #demo
    function handleDemoHash() {
        if (window.location.hash === '#demo') {
            const $modal = $('#contato-modal');
            if ($modal.length) {
                openContatoModalAndFocusNome();
            } else {
                // Se modal não existe ainda, tentar novamente
                setTimeout(handleDemoHash, 100);
            }
        }
    }

    // Verificar ao carregar a página (após tudo estar pronto)
    $(window).on('load', function () {
        setTimeout(handleDemoHash, 100);
    });

    // Verificar imediatamente (caso o DOM já esteja pronto)
    setTimeout(handleDemoHash, 500);

    // Verificar mudanças no hash
    $(window).on('hashchange', function () {
        if (window.location.hash === '#demo') {
            handleDemoHash();
        } else {
            // Se mudou para outro hash, fechar modal se estiver aberto
            const $modal = $('#contato-modal');
            if ($modal.hasClass('active')) {
                $modal.removeClass('active');
                $('body').css('overflow', '');
                resetForm();
            }
        }
    });

    // Interceptar TODOS os cliques em links com #demo (usando jQuery delegation)
    $(document).on('click', 'a[href="#demo"]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Atualizar hash
        window.location.hash = '#demo';

        // Abrir modal imediatamente
        setTimeout(function () {
            openContatoModalAndFocusNome();
        }, 10);

        return false;
    });

    // ============================================
    // FORMULÁRIO DE CANDIDATURA
    // ============================================
    
    // Aplicar máscara no campo de telefone
    if ($('#candidatura-telefone').length) {
        $('#candidatura-telefone').mask('(00) 00000-0000');
    }
    
    // Preview do arquivo selecionado
    $(document).on('change', '#candidatura-curriculo', function() {
        const file = this.files[0];
        const $preview = $('.file-preview');
        const $label = $('.file-upload-label');
        const $text = $('.file-upload-text');
        
        if (file) {
            // Validar tamanho (5MB)
            const maxSize = 5 * 1024 * 1024;
            if (file.size > maxSize) {
                $preview.html('<p>Arquivo muito grande. Tamanho máximo: 5MB</p>').addClass('form-message--error').show();
                $(this).val('');
                $label.removeClass('file-selected');
                return;
            }
            
            // Validar tipo
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            const allowedExts = ['pdf', 'doc', 'docx'];
            const fileExt = file.name.split('.').pop().toLowerCase();
            
            if (!allowedTypes.includes(file.type) && !allowedExts.includes(fileExt)) {
                $preview.html('<p>Tipo de arquivo não permitido. Use PDF, DOC ou DOCX</p>').addClass('form-message--error').show();
                $(this).val('');
                $label.removeClass('file-selected');
                return;
            }
            
            // Arquivo válido
            $label.addClass('file-selected');
            $text.text(file.name);
            $preview.removeClass('form-message--error').html('<p>' + file.name + ' (' + (file.size / 1024).toFixed(2) + ' KB)</p>').show();
        } else {
            $preview.hide();
            $label.removeClass('file-selected');
            $text.text('Escolher arquivo');
        }
    });

    // Submit do formulário de candidatura
    $(document).on('submit', '#form-candidatura', function(e) {
        e.preventDefault();
        
        const $form = $(this);
        const $loading = $('.loading-candidatura');
        const $message = $('.form-message');
        const $submitBtn = $form.find('button[type="submit"]');
        const $fileInput = $('#candidatura-curriculo');
        
        // Resetar mensagem
        $message.hide().find('p').text('');
        
        // Validar campos
        const nome = $('#candidatura-nome').val().trim();
        const email = $('#candidatura-email').val().trim();
        const telefone = $('#candidatura-telefone').val().trim();
        const file = $fileInput[0].files[0];
        const vagaId = $form.data('vaga-id');
        
        if (!nome || !email || !telefone || !file || !vagaId) {
            $message.removeClass('form-message--success').addClass('form-message--error');
            $message.find('p').text('Por favor, preencha todos os campos obrigatórios.');
            $message.show();
            return;
        }
        
        // Desabilitar formulário
        $form.find('input, textarea, button').prop('disabled', true);
        $loading.show();
        $submitBtn.text('Enviando...');
        
        // Primeiro fazer upload do arquivo
        const formData = new FormData();
        formData.append('file', file);
        
        axios.post(candidatura_api.restUrl + candidatura_api.uploadCv, formData, {
            headers: {
                'X-WP-Nonce': candidatura_api.nonce,
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(function(uploadResponse) {
            if (uploadResponse.data && uploadResponse.data.attachment_id) {
                // Upload bem-sucedido, agora enviar candidatura
                const mensagem = $('#candidatura-mensagem').val().trim();
                
                return axios.post(candidatura_api.restUrl + candidatura_api.submitCandidatura, {
                    nome: nome,
                    email: email,
                    telefone: telefone,
                    mensagem: mensagem,
                    vaga_id: vagaId,
                    attachment_id: uploadResponse.data.attachment_id
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': candidatura_api.nonce
                    }
                });
            } else {
                throw new Error('Erro no upload do arquivo');
            }
        })
        .then(function(response) {
            $loading.hide();
            
            if (response.data && response.data.success) {
                // Sucesso
                $form[0].reset();
                $('.file-preview').hide();
                $('.file-upload-label').removeClass('file-selected');
                $('.file-upload-text').text('Escolher arquivo');
                $message.removeClass('form-message--error').addClass('form-message--success');
                $message.find('p').text('Candidatura enviada com sucesso! Entraremos em contato em breve.');
                $message.show();
                
                // Scroll para mensagem
                $('html, body').animate({
                    scrollTop: $message.offset().top - 100
                }, 500);
            } else {
                throw new Error(response.data?.message || 'Erro ao enviar candidatura');
            }
        })
        .catch(function(error) {
            $loading.hide();
            const errorMsg = error.response?.data?.message || 
                           error.response?.data?.data?.message || 
                           error.message || 
                           'Erro ao enviar candidatura. Tente novamente.';
            
            $message.removeClass('form-message--success').addClass('form-message--error');
            $message.find('p').text(errorMsg);
            $message.show();
        })
        .finally(function() {
            // Reabilitar formulário
            $form.find('input, textarea, button').prop('disabled', false);
            $submitBtn.text('Enviar Candidatura');
        });
    });

    // ============================================
    // CARROSSEL DO TIME (Vagas)
    // ============================================
    const $timeCarousel = $('#time-carousel');
    if ($timeCarousel.length && $timeCarousel.find('.item').length > 0) {
        $timeCarousel.owlCarousel({
            loop: $timeCarousel.find('.item').length > 1,
            margin: 24,
            nav: true,
            dots: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1,
                    nav: false,
                    dots: true
                },
                768: {
                    items: 1,
                    nav: true
                },
                1024: {
                    items: 1,
                    nav: true
                },
                1200: {
                    items: 1,
                    nav: true
                }
            },
            navText: [
                '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" transform="matrix(-1 0 0 1 32 0)" fill="url(#paint0_linear_time_prev)"/><path d="M20 24L12 16L20 8" stroke="#000716" stroke-linecap="round"/><defs><linearGradient id="paint0_linear_time_prev" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse"><stop stop-color="#7AE2E6"/><stop offset="1" stop-color="#5D83C0"/></linearGradient></defs></svg>',
                '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="url(#paint0_linear_time_next)"/><path d="M12 24L20 16L12 8" stroke="#000716" stroke-linecap="round"/><defs><linearGradient id="paint0_linear_time_next" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse"><stop stop-color="#7AE2E6"/><stop offset="1" stop-color="#5D83C0"/></linearGradient></defs></svg>'
            ]
        });
    }
});